import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsString, IsUUID, Matches } from 'class-validator';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { RegionTimeWindowInterface } from '../interfaces/region-time-window.interface';
import { RegionDto } from '../../region/dto/region.dto';
import { RegionTimeType } from '../enums/region-time-window.enum';

@Exclude()
export class RegionTimeWindowDto
  extends CommonEntityDto
  implements RegionTimeWindowInterface
{
  @ApiProperty({ required: true })
  @IsUUID()
  @Expose()
  regionId!: string;

  @ApiProperty({
    description: 'Window start time of the window in HH:MM:SS format',
    example: '08:00:00',
  })
  @IsNotEmpty()
  @IsString()
  @Matches(/^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, {
    message: 'startTime must be in HH:MM:SS format',
  })
  @Expose()
  windowStartTime!: string;

  @ApiProperty({
    description: 'Window end time of the window in HH:MM:SS format',
    example: '22:00:00',
  })
  @IsNotEmpty()
  @IsString()
  @Matches(/^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, {
    message: 'endTime must be in HH:MM:SS format',
  })
  @Expose()
  windowEndTime!: string;

  @ApiProperty({
    title: 'Region Time Type',
    type: 'enum',
    enum: RegionTimeType,
  })
  @IsEnum(RegionTimeType)
  @Expose()
  regionTimeType!: RegionTimeType;

  @ApiPropertyOptional({
    type: () => RegionDto,
    title: 'Associated Region',
    description: 'The region associated with this time window',
  })
  @Expose()
  region?: RegionDto;
}
